/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { Component, OnInit } from '@angular/core';

import { XmStore } from 'core/services';
import { StateService } from '@uirouter/core';
import { ProgressStatus } from 'my-account/constants';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';

@Component({
    selector: 'xm-addon-summary',
    templateUrl: './addon-summary.html',
    styleUrls: ['./addon-summary.scss'],
    standalone: false
})

export class XmAddonSummary implements OnInit {
    private addonsUtil: AddonsUtil;

    constructor(xmStore: XmStore, state: StateService, addonsUtil: AddonsUtil) {
        Object.assign(this, { xmStore, state, addonsUtil });
    }

    public ngOnInit(): void {
        this.addonsUtil.addonsPollingStatus$.next(ProgressStatus.SUMMARY);
    }
}
